var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.47 36.4299C29.2344 36.4299 37.15 28.5143 37.15 18.7499C37.15 8.98555 29.2344 1.06995 19.47 1.06995C9.70558 1.06995 1.78998 8.98555 1.78998 18.7499C1.78998 28.5143 9.70558 36.4299 19.47 36.4299Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.95 23.42C18.95 21.44 19.5 19.83 20.84 18.54C22.55 16.94 23.41 15.37 23.41 13.85C23.41 12.7 23.05 11.8 22.33 11.14C21.61 10.48 20.66 10.16 19.48 10.16C17.57 10.16 16.26 11.07 15.54 12.89",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9499 28.9601C21.0399 28.9601 21.0399 25.7101 18.9499 25.7101C16.8599 25.7101 16.8599 28.9601 18.9499 28.9601Z",
    fill: "#00C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskExpert);
export default __webpack_public_path__ + "static/media/ask-expert.c6d711ad8bc447fb41a82515d1ea3b2c.svg";
export { ForwardRef as ReactComponent };